module.exports = __webpack_public_path__ + "img/cricle_1.0a0538df.png";